import Vue from 'vue'
import App from './App'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import 'moment/locale/zh-cn';
// import '@/utils/permission'
import {router} from './router'
import AxiosUtils from '@/utils/AxiosUtils'
import {store} from '@/utils/store'
import CLayout from '@/components/c-layout';
import '../public/color.less'
import SlideVerify from 'vue-monoplasty-slide-verify';
import 'moment/locale/zh-cn';


Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(SlideVerify);
Vue.prototype.$http = AxiosUtils
Vue.component('CLayout', CLayout)
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
